// Re-exporter from profile.json single source of truth.
// Refactored per emergent-portfolio-master-v3 §3.1: Feb 14, 2026.

import profile from "../../data/profile.json";

export const SUMMARY_VIDEO_URL = profile.summaryVideoUrl;

export const SKILLS_CONTENT = {
  competencies: profile.skills.coreCompetencies,
  tools:        profile.skills.tools,
  categories:   profile.skills.categories,
  overview: [
    "Over the years, I have worn multiple hats — sometimes by choice, sometimes by necessity, always with ownership. Designer, animator, content creator, UX practitioner, trainer, project manager, creative director, founder, intrapreneur. Each role added a new lens to how I approach problems, people, and outcomes.",
    "My project exposure spans brand building, marketing communication, corporate communication, learning & development, HR and recruitment branding, digital transformation, UX and experience design, animation and motion storytelling, training content, and AI-assisted learning systems — from early-stage idea validation to large-scale execution.",
    "Delivered work for startups, educational institutions, government bodies, manufacturing organisations, global enterprises and social impact initiatives — as an individual contributor, a team leader and a strategic partner to founders, CXOs, HR leaders and educators.",
  ],
  legend: [
    ["Beginner",     "Basic understanding"],
    ["Intermediate", "Independent work"],
    ["Competent",    "Confident in projects"],
    ["Advanced",     "Complex scenarios"],
    ["Expert",       "Strategy & mentorship"],
  ],
};

export const EDUCATION_CONTENT = {
  formal: profile.education.map((e) => ({
    degree: e.degree,
    institute: e.institute,
    affiliation: e.affiliation,
    year: e.endYear
      ? `${/^certification/i.test(e.degree) ? "Completed" : "Graduated"} ${e.endYear}`
      : "",
    awards: e.awards,
  })),
  upskilling: profile.certifications.map((c) => ({
    title: c.title,
    issuer: c.issuer,
    status: c.year ? `Completed ${c.year}` : "Completed",
  })),
  certificates: Array.from({ length: 8 }, (_, i) =>
    `https://bfeecpnbxuymxnmokuav.supabase.co/storage/v1/object/public/Assets/Images/Certificates/${i + 1}.png`
  ),
};

export const TESTIMONIALS_CONTENT = {
  intro: profile.testimonials.intro,
  items: profile.testimonials.items.map((t) => ({
    name: t.name, role: t.role, avatar: t.avatar, quote: t.quote, contact: t.contact,
  })),
};

export const MEDIA_CONTENT = profile.media;
export const GALLERY_CONTENT = profile.gallery;
export const SOCIAL_CONTENT  = { intro: profile.socialInitiatives.intro, initiatives: profile.socialInitiatives.items };
export const BLOG_CONTENT    = profile.blog;

// Merged "Exposure & Social Impact" — combines exposure chapters,
// social impact (WEF Global Shapers) and mentorship (School of Passion).
export const EXPOSURE_SOCIAL_CONTENT = profile.exposureSocial;

export const MOREINFO_CONTENT = {
  personal:   profile.moreInfo.personal,
  references: profile.moreInfo.references,
};
